package com.starparty.app.astro0.celestialbodies

class OrbitalElementsData(
    c_N: Double,  // Constant for longitude of the ascending node;
    a_N: Double,  // Coefficient for longitude of the ascending node;
    c_i: Double,  // i = inclination to the ecliptic (plane of the Earth's orbit)
    a_i: Double,  // i = inclination to the ecliptic (plane of the Earth's orbit)
    c_w: Double,  // argument of perihelion
    a_w: Double,  // argument of perihelion
    c_a: Double,  // semi-major axis, or mean distance from Sun
    a_a: Double,  // semi-major axis, or mean distance from Sun
    c_e: Double,  // eccentricity (0=circle, 0-1=ellipse, 1=parabola)
    a_e: Double,  // eccentricity (0=circle, 0-1=ellipse, 1=parabola)
    c_M: Double,  // mean anomaly (0 at perihelion; increases uniformly with time)
    a_M: Double // mean anomaly (0 at perihelion; increases uniformly with time)
) {
    var mConstants: DoubleArray
    var mCoeffs: DoubleArray

    init {
        mConstants = doubleArrayOf(c_N, c_i, c_w, c_a, c_e, c_M)
        mCoeffs = doubleArrayOf(a_N, a_i, a_w, a_a, a_e, a_M)
    }
}